import React, {Component} from 'react';
import { observable, action } from 'mobx';
import { observer, inject } from 'mobx-react';
import {Link} from "react-router-dom";
import moment from "moment/moment";
import 'react-toastify/dist/ReactToastify.css';
import PageTitle from "../../../components/common/PageTitle";
import FeatherIcon from 'feather-icons-react';
import {
  FormInput
} from "shards-react";
import 'react-calendar/dist/Calendar.css';
import './style.scss'
import ModalLoading from "../../../components/common/ModalLoading";

@inject(({ teamUser }) => ({ isLogin: teamUser.isLogin, me:teamUser.me }))
@inject(({ common }) => ({ getDoc: common.getDoc, getStoreTotalConfig: common.getStoreTotalConfig, getMsgList: common.getMsgList, getMsgStats: common.getMsgStats }))
@inject(({ review }) => ({ getReviewList:review.getReviewList, setReviewSync: review.setReviewSync,
  updateReviewDisplayStatus: review.updateReviewDisplayStatus, updateReviewSome: review.updateReviewSome, updateReviewComment: review.updateReviewComment, genAIComment: review.genAIComment, commentSmartCorrent: review.commentSmartCorrent, adminDelReview:review.adminDelReview,
  getStatusReviewBoard: review.getStatusReviewBoard, downloadFile : review.downloadFile }))
@inject(({ widget }) => ({ getWidgetList:widget.getWidgetList, getWidgetInReviewList:widget.getWidgetInReviewList, updateWidgetInReview: widget.updateWidgetInReview, updateWidgetInReviewOrder: widget.updateWidgetInReviewOrder, removeWidgetInReview: widget.removeWidgetInReview }))
@inject(({ AOA }) => ({ adminCusData:AOA.adminCusData }))


@observer
class MsgList extends Component {

  //basic
  @observable store = {};
  @observable teamUser = {};
  @observable permissions = {}
  @observable company = {};
  @observable isLogin = false;
  @observable isLoading = true;
  @observable urlParams = new URLSearchParams(window.location.search);

  //page
  @observable initialGetReviewList = true;
  @observable isShowDetailSearch = true;

  @observable serarchPeriod = [3, "months", "3개월 단위"];
  @observable searchFormValue = {
    searchType: 'all',
    keyword: '',
    // startDate: moment().add(-7, 'days').format('yyyy-MM-DD'),
    // endDate: moment().format('yyyy-MM-DD'),
    startDate: "",
    endDate: "",
    star: {
      all: true,
      star5: true,
      star4: true,
      star3: true,
      star2: true,
      star1: true,
    },
    writer: {
      all: true,
      member: true,
      admin: true,
    },
    reviewType: {
      all: true,
      text: true,
      image: true,
      // movie: true,
      // survey: true,
    },
    reviewDis: {
      all: true,
      on: true,
      will: true,
      pending: true,
    },
    isDelete: false,
    noComment: false
  };
  @observable syncReviewValue = {
    startDate: moment().add(-1, 'days').format('yyyy-MM-DD'),
    endDate: moment().format('yyyy-MM-DD'),
    isOverwrite: false,
  };
  @observable basicSettings = {};

  @observable isShowCalendar = {
    startDate: false,
    endDate: false
  }



  @observable listParams = {
    page:1, limit:25,
    searchParams: { },
    shopNo: 1
  }
  @observable list = {};

  // 통계 대시보드용
  @observable stats = {
    totalSent: 0,
    thisMonthSent: 0,
    lastMonthSent: 0,
    successCount: 0,
    failCount: 0,
    pendingCount: 0,
    monthDelta: null,
    totalCharged: 0
  };
  @observable isStatsLoading = true;

  // 2단계: 필터 툴바 상태
  @observable filters = {
    keyword: '',
    status: 'all',     // all | SENT | FAILED | PENDING
    datePreset: 'all', // all | today | 7d | 30d | custom
    startDate: '',
    endDate: ''
  };

  // 3단계: 정렬
  @observable sort = {
    field: 'createdAt',  // createdAt | status | receiver
    dir: 'desc'          // asc | desc
  };

  @observable modals = {
    isSyncReview: false,
    data: {}
  };

  constructor(props) {
    super(props);
    this.init()
  }

  @action
  init = async (key) => {

    if(this.props.isLogin) {
      //basic
      this.isLogin = this.props.isLogin;
      this.teamUser = this.props.me;
      this.store = this.props.me.store ? this.props.me.store : {};
      this.listParams.store_id = this.teamUser.selStore_id;
      // this.listParams.shopNo = this.teamUser.selShopNo ? this.teamUser.selShopNo : 1;
      this.urlParamsToListParams();
    }


  };

  urlParamsToListParams = function() {

    let searchFormValueArr = {};
    for (const key of this.urlParams.keys()) {

      if(['page'].indexOf(key) > -1 || ['limit'].indexOf(key) > -1) {
        this.listParams[key] = parseInt(this.urlParams.get(key));
      }
      else {
        if(key.indexOf('__') > -1) {
          let keyArr = key.split('__');
          if(!searchFormValueArr[keyArr[0]]) { searchFormValueArr[keyArr[0]] = {};}
          searchFormValueArr[keyArr[0]][keyArr[1]] = true;
        }
        else {
          this.searchFormValue[key] = this.urlParams.get(key);
          this.listParams.searchParams[key] = this.urlParams.get(key);
        }
      }
    }

    for(let key in searchFormValueArr) {
      if(searchFormValueArr[key].all) {
        for(let deKey in this.searchFormValue[key]) {
          this.searchFormValue[key][deKey] = true;
        }
      }
      else {
        for(let deKey in this.searchFormValue[key]) {
          if(searchFormValueArr[key][deKey]) {
            this.searchFormValue[key][deKey] = true;
          }
          else {
            this.searchFormValue[key][deKey] = false;
          }
        }
      }
      this.listParams.searchParams[key] = searchFormValueArr[key];
    }

    this.getDataNeed();
  }


  //ui fn
  getDataNeed = async () => {
    const [list, statsRes] = await Promise.all([
      this.props.getMsgList(this.listParams),
      this.props.getMsgStats({
        store_id: this.teamUser.selStore_id,
        shopNo: this.teamUser.selShopNo || 1
      })
    ]);
    this.list = list;
    if (statsRes && statsRes.data) {
      this.stats = { ...this.stats, ...statsRes.data };
    }
    this.isStatsLoading = false;
    this.isLoading = false;
  }

  goToCharge = async () => {
    let url = '/msgOrder';
    window.location.href = url;
  }

  // 2단계: 필터 적용 → listParams.searchParams 동기화 후 재조회
  @action
  applyFilters = async () => {
    const sp = {};
    if (this.filters.keyword && this.filters.keyword.trim()) sp.keyword = this.filters.keyword.trim();
    if (this.filters.status && this.filters.status !== 'all') sp.status = this.filters.status;
    if (this.filters.startDate) sp.startDate = this.filters.startDate;
    if (this.filters.endDate) sp.endDate = this.filters.endDate;
    sp.sortField = this.sort.field;
    sp.sortDir = this.sort.dir;

    this.listParams.searchParams = sp;
    this.listParams.page = 1;
    this.isLoading = true;
    this.list = await this.props.getMsgList(this.listParams);
    this.isLoading = false;
  }

  // 3단계: 헤더 클릭으로 정렬 토글
  @action
  toggleSort = (field) => {
    if (this.sort.field === field) {
      this.sort.dir = this.sort.dir === 'asc' ? 'desc' : 'asc';
    } else {
      this.sort.field = field;
      this.sort.dir = 'desc';
    }
    this.applyFilters();
  }


  @action
  setDatePreset = (preset) => {
    this.filters.datePreset = preset;
    const today = moment();
    if (preset === 'today') {
      this.filters.startDate = today.format('YYYY-MM-DD');
      this.filters.endDate = today.format('YYYY-MM-DD');
    } else if (preset === '7d') {
      this.filters.startDate = today.clone().subtract(6, 'days').format('YYYY-MM-DD');
      this.filters.endDate = today.format('YYYY-MM-DD');
    } else if (preset === '30d') {
      this.filters.startDate = today.clone().subtract(29, 'days').format('YYYY-MM-DD');
      this.filters.endDate = today.format('YYYY-MM-DD');
    } else if (preset === 'all') {
      this.filters.startDate = '';
      this.filters.endDate = '';
    }
    if (preset !== 'custom') {
      this.applyFilters();
    }
  }

  @action
  setStatus = (status) => {
    this.filters.status = status;
    this.applyFilters();
  }

  @action
  onChangeKeyword = (e) => {
    this.filters.keyword = e.target.value;
  }

  onSearchSubmit = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      this.applyFilters();
    }
  }

  @action
  clearFilter = (key) => {
    if (key === 'keyword') this.filters.keyword = '';
    else if (key === 'status') this.filters.status = 'all';
    else if (key === 'date') {
      this.filters.datePreset = 'all';
      this.filters.startDate = '';
      this.filters.endDate = '';
    }
    this.applyFilters();
  }

  @action
  resetAllFilters = () => {
    this.filters = {
      keyword: '',
      status: 'all',
      datePreset: 'all',
      startDate: '',
      endDate: ''
    };
    this.applyFilters();
  }



  adminCusData = async() => {
    let updateData = {
      store_id: this.store._id,
      shopNo: this.teamUser.selShopNo ? this.teamUser.selShopNo : 1,
    }
    // console.log('updateMassReview', updateData);
    this.props.adminCusData(updateData, function(res) {
      console.log(res);

    });
  }

  // 5단계: 페이지 변경
  @action
  goToPage = async (page) => {
    if (page < 1) return;
    if (this.list && this.list.totalPages && page > this.list.totalPages) return;
    this.listParams.page = page;
    this.isLoading = true;
    this.list = await this.props.getMsgList(this.listParams);
    this.isLoading = false;
  }

  // 5단계: 페이지당 표시 건수 변경
  @action
  changePageSize = async (size) => {
    this.listParams.limit = parseInt(size);
    this.listParams.page = 1;
    this.isLoading = true;
    this.list = await this.props.getMsgList(this.listParams);
    this.isLoading = false;
  }

  render() {
    let _this = this;

    // 5단계: 정보형 페이지네이션 바
    const PaginationBar = () => {
      const total = (_this.list && _this.list.totalDocs) || 0;
      const totalPages = (_this.list && _this.list.totalPages) || 0;
      const curPage = (_this.list && _this.list.page) || _this.listParams.page;
      const limit = (_this.list && _this.list.limit) || _this.listParams.limit;
      const fromNum = total === 0 ? 0 : (curPage - 1) * limit + 1;
      const toNum = Math.min(curPage * limit, total);

      // 페이지 번호 계산 — 최대 7개 표시 (현재 페이지 ± 3)
      const buildPageNumbers = () => {
        const pages = [];
        if (totalPages <= 7) {
          for (let i = 1; i <= totalPages; i++) pages.push(i);
        } else {
          if (curPage <= 4) {
            pages.push(1, 2, 3, 4, 5, '...', totalPages);
          } else if (curPage >= totalPages - 3) {
            pages.push(1, '...', totalPages - 4, totalPages - 3, totalPages - 2, totalPages - 1, totalPages);
          } else {
            pages.push(1, '...', curPage - 1, curPage, curPage + 1, '...', totalPages);
          }
        }
        return pages;
      };

      return (
        <div className="msglist-pagination" role="navigation" aria-label="페이지 네비게이션">
          {/* 좌측: 결과 정보 */}
          <div className="pagination-info">
            전체 <strong>{total.toLocaleString()}</strong>건 중 <strong>{fromNum.toLocaleString()}-{toNum.toLocaleString()}</strong>건 표시
          </div>

          {/* 중앙: 페이지 네비게이션 */}
          {totalPages > 1 && (
            <div className="pagination-nav">
              <button type="button"
                      className="pagination-arrow"
                      disabled={curPage <= 1}
                      onClick={() => _this.goToPage(curPage - 1)}
                      aria-label="이전 페이지">
                <FeatherIcon icon="chevron-left" size="14" aria-hidden="true" />
                <span>이전</span>
              </button>
              <div className="pagination-numbers">
                {buildPageNumbers().map((p, idx) => (
                  p === '...' ? (
                    <span key={`gap-${idx}`} className="pagination-gap">…</span>
                  ) : (
                    <button key={p}
                            type="button"
                            className={`pagination-num ${p === curPage ? 'is-current' : ''}`}
                            onClick={() => _this.goToPage(p)}
                            aria-label={`${p} 페이지로 이동`}
                            aria-current={p === curPage ? 'page' : undefined}>
                      {p}
                    </button>
                  )
                ))}
              </div>
              <button type="button"
                      className="pagination-arrow"
                      disabled={curPage >= totalPages}
                      onClick={() => _this.goToPage(curPage + 1)}
                      aria-label="다음 페이지">
                <span>다음</span>
                <FeatherIcon icon="chevron-right" size="14" aria-hidden="true" />
              </button>
            </div>
          )}

          {/* 우측: 페이지당 표시 건수 */}
          <div className="pagination-pagesize">
            <label htmlFor="pagesize-select" className="pagesize-label">페이지당</label>
            <select id="pagesize-select"
                    className="pagesize-select"
                    value={limit}
                    onChange={(e) => _this.changePageSize(e.target.value)}
                    aria-label="페이지당 표시 건수">
              <option value="20">20건</option>
              <option value="50">50건</option>
              <option value="100">100건</option>
            </select>
          </div>
        </div>
      );
    };

    // 통계 대시보드 헬퍼
    const quota = (this.store && this.store.messageQuota) || 0;
    const totalCharged = this.stats.totalCharged || 0;
    // 진행률: 보유 / 누적 충전량 (충전 이력이 없으면 quota 자체로 100%)
    const quotaPct = totalCharged > 0
      ? Math.min(100, Math.max(2, Math.round((quota / totalCharged) * 100)))
      : (quota > 0 ? 100 : 0);
    const quotaLevel = quota <= 200 ? 'danger' : (quota <= 300 ? 'warn' : 'ok');

    const totalSent = this.stats.totalSent || 0;
    const thisMonth = this.stats.thisMonthSent || 0;
    const lastMonth = this.stats.lastMonthSent || 0;
    const monthDelta = this.stats.monthDelta;

    const successCount = this.stats.successCount || 0;
    const failCount = this.stats.failCount || 0;
    const totalAttempts = successCount + failCount;
    const successRate = totalAttempts > 0 ? Math.round((successCount / totalAttempts) * 100) : 0;

    const renderDelta = (delta) => {
      if (delta === null || delta === undefined) return null;
      if (delta === 0) {
        return <span className="stat-delta stat-delta-neutral">변동 없음</span>;
      }
      const isUp = delta > 0;
      return (
        <span className={`stat-delta ${isUp ? 'stat-delta-up' : 'stat-delta-down'}`}>
          <FeatherIcon icon={isUp ? 'arrow-up-right' : 'arrow-down-right'} size="12" aria-hidden="true" />
          {Math.abs(delta)}%
          <span className="stat-delta-text">전월 대비</span>
        </span>
      );
    };

    return (
      <div className="main-content msglist-redesign">
        <PageTitle />

        {/* === 1단계: 4분할 통계 대시보드 === */}
        <div className="msglist-stats-grid">
          {/* 카드 ① 보유 알림톡 */}
          <div className={`stats-card stats-quota stats-quota-${quotaLevel}`}>
            <div className="stats-card-head">
              <div className="stats-icon stats-icon-quota">
                <FeatherIcon icon="message-circle" size="18" aria-hidden="true" />
              </div>
              <div className="stats-card-meta">
                <div className="stats-label">보유 알림톡</div>
                {quotaLevel !== 'ok' && (
                  <span className={`stats-badge stats-badge-${quotaLevel === 'danger' ? 'danger' : 'warn'}`}>
                    <FeatherIcon icon="alert-triangle" size="10" aria-hidden="true" />
                    {quotaLevel === 'danger' ? '잔량 부족' : '충전 권장'}
                  </span>
                )}
              </div>
            </div>
            <div className="stats-value-row">
              <strong className="stats-value">{quota.toLocaleString()}</strong>
              <span className="stats-unit">건</span>
            </div>
            <div className="stats-quota-progress">
              <div className="stats-progress-track">
                <div className="stats-progress-fill" style={{width: `${quotaPct}%`}} />
              </div>
              <div className="stats-progress-meta">
                <span>잔량 {quotaPct}%</span>
                {totalCharged > 0 && (
                  <span>누적 충전 {totalCharged.toLocaleString()}건</span>
                )}
              </div>
            </div>
            <button type="button" className="stats-cta-outline"
                    onClick={() => this.goToCharge()}
                    aria-label={`알림톡 충전하기. 현재 ${quota.toLocaleString()}건 보유`}>
              <FeatherIcon icon="zap" size="13" aria-hidden="true" />
              <span>충전하기</span>
              <FeatherIcon icon="arrow-right" size="13" aria-hidden="true" />
            </button>
          </div>

          {/* 카드 ② 총 발송 건수 */}
          <div className="stats-card">
            <div className="stats-card-head">
              <div className="stats-icon stats-icon-total">
                <FeatherIcon icon="send" size="18" aria-hidden="true" />
              </div>
              <div className="stats-card-meta">
                <div className="stats-label">총 발송 건수</div>
                <div className="stats-sub">전체 누적</div>
              </div>
            </div>
            <div className="stats-value-row">
              <strong className="stats-value">{totalSent.toLocaleString()}</strong>
              <span className="stats-unit">건</span>
            </div>
            <div className="stats-footer">
              <span className="stats-foot-key">성공 {successCount.toLocaleString()}건</span>
              <span className="stats-foot-divider">·</span>
              <span className="stats-foot-key" style={{color: '#dc2626'}}>실패 {failCount.toLocaleString()}건</span>
            </div>
          </div>

          {/* 카드 ③ 이번 달 발송 */}
          <div className="stats-card">
            <div className="stats-card-head">
              <div className="stats-icon stats-icon-month">
                <FeatherIcon icon="calendar" size="18" aria-hidden="true" />
              </div>
              <div className="stats-card-meta">
                <div className="stats-label">이번 달 발송</div>
                <div className="stats-sub">{moment().format('YYYY년 M월')}</div>
              </div>
            </div>
            <div className="stats-value-row">
              <strong className="stats-value">{thisMonth.toLocaleString()}</strong>
              <span className="stats-unit">건</span>
            </div>
            <div className="stats-footer">
              {renderDelta(monthDelta)}
              {monthDelta === null && (
                <span className="stats-foot-key">지난 달 {lastMonth.toLocaleString()}건</span>
              )}
            </div>
          </div>

          {/* 카드 ④ 발송 성공률 */}
          <div className="stats-card">
            <div className="stats-card-head">
              <div className="stats-icon stats-icon-success">
                <FeatherIcon icon="check-circle" size="18" aria-hidden="true" />
              </div>
              <div className="stats-card-meta">
                <div className="stats-label">발송 성공률</div>
                <div className="stats-sub">전체 시도 기준</div>
              </div>
            </div>
            <div className="stats-success-row">
              <div className="stats-circle" role="img" aria-label={`성공률 ${successRate}%`}>
                <svg viewBox="0 0 36 36" width="64" height="64">
                  <path className="circle-bg" d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"/>
                  <path className="circle-fill" strokeDasharray={`${successRate}, 100`}
                        d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"/>
                </svg>
                <div className="stats-circle-value">{successRate}<span>%</span></div>
              </div>
              <div className="stats-success-detail">
                <div className="stats-foot-key" style={{color: '#10b981'}}>
                  <FeatherIcon icon="check" size="11" aria-hidden="true" /> 성공 {successCount.toLocaleString()}
                </div>
                <div className="stats-foot-key" style={{color: '#dc2626'}}>
                  <FeatherIcon icon="x" size="11" aria-hidden="true" /> 실패 {failCount.toLocaleString()}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* === 2단계: 검색 & 필터 툴바 === */}
        <div className="msglist-toolbar">
          <div className="toolbar-row">
            {/* 검색 입력 */}
            <div className="toolbar-search">
              <FeatherIcon icon="search" size="14" aria-hidden="true" className="toolbar-search-icon" />
              <input
                type="text"
                className="toolbar-search-input"
                placeholder="주문내용, 주문자명 검색..."
                value={this.filters.keyword}
                onChange={this.onChangeKeyword}
                onKeyDown={this.onSearchSubmit}
                aria-label="알림톡 발송 내역 검색 (주문내용 또는 주문자명)"
              />
              {this.filters.keyword && (
                <button type="button" className="toolbar-search-clear"
                        onClick={() => { this.filters.keyword = ''; this.applyFilters(); }}
                        aria-label="검색어 지우기">
                  <FeatherIcon icon="x" size="13" />
                </button>
              )}
            </div>

            {/* 날짜 프리셋 */}
            <div className="toolbar-date-presets" role="radiogroup" aria-label="기간 선택">
              {[
                {key: 'all',   label: '전체'},
                {key: 'today', label: '오늘'},
                {key: '7d',    label: '최근 7일'},
                {key: '30d',   label: '최근 30일'},
                {key: 'custom',label: '직접 입력'},
              ].map(p => (
                <button key={p.key} type="button"
                        role="radio"
                        aria-checked={this.filters.datePreset === p.key}
                        className={`toolbar-preset ${this.filters.datePreset === p.key ? 'is-active' : ''}`}
                        onClick={() => this.setDatePreset(p.key)}>
                  {p.label}
                </button>
              ))}
            </div>

          </div>

          {/* 커스텀 날짜 입력 */}
          {this.filters.datePreset === 'custom' && (
            <div className="toolbar-row toolbar-row-custom">
              <div className="toolbar-date-custom">
                <FormInput type="date" size="sm"
                           value={this.filters.startDate}
                           onChange={(e) => this.filters.startDate = e.target.value}
                           aria-label="시작일"
                           style={{maxWidth: '160px'}}/>
                <span className="toolbar-date-sep">~</span>
                <FormInput type="date" size="sm"
                           value={this.filters.endDate}
                           onChange={(e) => this.filters.endDate = e.target.value}
                           aria-label="종료일"
                           style={{maxWidth: '160px'}}/>
                <button type="button" className="toolbar-date-apply"
                        onClick={() => this.applyFilters()}>
                  적용
                </button>
              </div>
            </div>
          )}

          {/* 발송 상태 세그먼트 */}
          <div className="toolbar-row">
            <div className="toolbar-status" role="radiogroup" aria-label="발송 상태 필터">
              {[
                {key: 'all',     label: '전체',    icon: 'list',           count: this.stats.totalSent},
                {key: 'SENT',    label: '발송완료', icon: 'check-circle',   count: this.stats.successCount, color: 'success'},
                {key: 'FAILED',  label: '발송실패', icon: 'x-circle',       count: this.stats.failCount,    color: 'danger'},
                {key: 'PENDING', label: '대기중',   icon: 'clock',          count: this.stats.pendingCount, color: 'warn'},
              ].map(s => (
                <button key={s.key} type="button"
                        role="radio"
                        aria-checked={this.filters.status === s.key}
                        className={`toolbar-status-btn ${this.filters.status === s.key ? 'is-active' : ''} toolbar-status-${s.color || 'neutral'}`}
                        onClick={() => this.setStatus(s.key)}>
                  <FeatherIcon icon={s.icon} size="13" aria-hidden="true" />
                  <span className="status-label">{s.label}</span>
                  <span className="status-count">{(s.count || 0).toLocaleString()}</span>
                </button>
              ))}
            </div>
          </div>

          {/* 활성 필터 칩 */}
          {(this.filters.keyword || this.filters.status !== 'all' || this.filters.datePreset !== 'all') && (
            <div className="toolbar-active-chips">
              <span className="chips-label">
                <FeatherIcon icon="filter" size="12" aria-hidden="true" />
                활성 필터
              </span>
              {this.filters.keyword && (
                <span className="filter-chip">
                  검색: <strong>{this.filters.keyword}</strong>
                  <button type="button" onClick={() => this.clearFilter('keyword')} aria-label="검색어 필터 해제">
                    <FeatherIcon icon="x" size="11" />
                  </button>
                </span>
              )}
              {this.filters.status !== 'all' && (
                <span className="filter-chip">
                  상태: <strong>{({SENT:'발송완료', FAILED:'발송실패', PENDING:'대기중'}[this.filters.status])}</strong>
                  <button type="button" onClick={() => this.clearFilter('status')} aria-label="상태 필터 해제">
                    <FeatherIcon icon="x" size="11" />
                  </button>
                </span>
              )}
              {this.filters.datePreset !== 'all' && (
                <span className="filter-chip">
                  기간: <strong>
                    {this.filters.datePreset === 'today' ? '오늘'
                      : this.filters.datePreset === '7d' ? '최근 7일'
                      : this.filters.datePreset === '30d' ? '최근 30일'
                      : `${this.filters.startDate || ''} ~ ${this.filters.endDate || ''}`}
                  </strong>
                  <button type="button" onClick={() => this.clearFilter('date')} aria-label="기간 필터 해제">
                    <FeatherIcon icon="x" size="11" />
                  </button>
                </span>
              )}
              <button type="button" className="filter-chip-reset" onClick={() => this.resetAllFilters()}>
                전체 해제
              </button>
            </div>
          )}
        </div>

        {/* === 3단계: 리디자인된 테이블 === */}
        {this.list && this.list.docs ? (
          <div className="msglist-table-card">
            {this.list.docs.length > 0 ? (
              <>
                <div className="msglist-table-wrap">
                  <table className="msglist-table">
                    <colgroup>
                      <col style={{width: '10%'}} />
                      <col />
                      <col style={{width: '14%'}} />
                      <col style={{width: '17%'}} />
                      <col style={{width: '9%'}} />
                    </colgroup>
                    <thead>
                      <tr>
                        <th className="msglist-th-sortable" onClick={() => this.toggleSort('status')}>
                          <span>발송상태</span>
                          {this.sort.field === 'status' && (
                            <FeatherIcon icon={this.sort.dir === 'asc' ? 'arrow-up' : 'arrow-down'} size="12" aria-hidden="true" />
                          )}
                        </th>
                        <th>주문내용</th>
                        <th>주문자</th>
                        <th className="msglist-th-sortable" onClick={() => this.toggleSort('createdAt')}>
                          <span>발송날짜</span>
                          {this.sort.field === 'createdAt' && (
                            <FeatherIcon icon={this.sort.dir === 'asc' ? 'arrow-up' : 'arrow-down'} size="12" aria-hidden="true" />
                          )}
                        </th>
                        <th className="text-center">재발송</th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.list.docs.map((item, i) => {
                        const productName = (item.order_id && item.order_id.orderProductName) || '-';
                        const receiverName = (item.order_id && item.order_id.receiverName) || '-';
                        const status = item.status || 'PENDING';
                        const statusInfo = {
                          SENT:    {label: '발송완료', color: 'success', icon: 'check-circle'},
                          FAILED:  {label: '발송실패', color: 'danger',  icon: 'x-circle'},
                          PENDING: {label: '대기중',   color: 'warn',    icon: 'clock'}
                        }[status] || {label: status, color: 'neutral', icon: 'help-circle'};

                        return (
                          <tr key={item._id || i} className="msglist-row">
                            <td>
                              <span className={`msglist-status-badge msglist-status-${statusInfo.color}`}>
                                <FeatherIcon icon={statusInfo.icon} size="11" aria-hidden="true" />
                                {statusInfo.label}
                              </span>
                            </td>
                            <td className="msglist-product-cell" title={productName}>
                              <div className="msglist-product-name">{productName}</div>
                            </td>
                            <td>
                              <div className="msglist-receiver">
                                {receiverName !== '-' && (
                                  <div className="msglist-receiver-name">{receiverName}</div>
                                )}
                                {item.receiver && (
                                  <div className="msglist-receiver-phone">{item.receiver}</div>
                                )}
                              </div>
                            </td>
                            <td>
                              <div className="msglist-date">
                                <div className="msglist-date-abs">{moment(item.createdAt).format('YYYY-MM-DD HH:mm')}</div>
                                <div className="msglist-date-rel">{moment(item.createdAt).fromNow()}</div>
                              </div>
                            </td>
                            <td className="text-center">
                              {item.totalAttempts > 1 ? (
                                <span className={`msglist-attempt-badge ${item.attemptNo > 1 ? 'is-resend' : ''}`}
                                      title={`동일 주문 ${item.totalAttempts}회 발송 중 ${item.attemptNo}번째`}>
                                  {item.attemptNo}/{item.totalAttempts}
                                </span>
                              ) : (
                                <span className="msglist-attempt-once">1차</span>
                              )}
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
                <PaginationBar/>
              </>
            ) : (
              /* 빈 상태 */
              <div className="msglist-empty">
                <div className="msglist-empty-illust" aria-hidden="true">
                  <svg viewBox="0 0 120 120" width="120" height="120">
                    <circle cx="60" cy="60" r="56" fill="#F1F5F9" />
                    <rect x="32" y="40" width="56" height="44" rx="8" fill="#fff" stroke="#94A3B8" strokeWidth="2" />
                    <circle cx="48" cy="62" r="3" fill="#94A3B8" />
                    <circle cx="60" cy="62" r="3" fill="#94A3B8" />
                    <circle cx="72" cy="62" r="3" fill="#94A3B8" />
                    <path d="M 50 80 L 32 92 L 50 92 Z" fill="#fff" stroke="#94A3B8" strokeWidth="2" strokeLinejoin="round"/>
                  </svg>
                </div>
                <h4 className="msglist-empty-title">발송 내역이 없습니다</h4>
                <p className="msglist-empty-desc">
                  {(this.filters.keyword || this.filters.status !== 'all' || this.filters.datePreset !== 'all')
                    ? '필터 조건에 맞는 발송 내역이 없습니다. 필터를 변경하거나 해제해 보세요.'
                    : '아직 발송된 알림톡이 없습니다. 알림톡 설정을 완료하고 주문을 받아보세요.'}
                </p>
                <div className="msglist-empty-actions">
                  {(this.filters.keyword || this.filters.status !== 'all' || this.filters.datePreset !== 'all') ? (
                    <button type="button" className="msglist-empty-btn" onClick={() => this.resetAllFilters()}>
                      <FeatherIcon icon="x" size="13" aria-hidden="true" />
                      필터 전체 해제
                    </button>
                  ) : (
                    <Link to="/kakaoMsgSetting" className="msglist-empty-btn msglist-empty-btn-primary">
                      <FeatherIcon icon="settings" size="13" aria-hidden="true" />
                      알림톡 설정 바로가기
                    </Link>
                  )}
                </div>
              </div>
            )}
          </div>
        ) : null }


        <ModalLoading isLoading={this.isLoading}/>
      </div>
    )
  }
}

export default MsgList;
